<template>

    <div style="min-height: 100vh; background: #fff; padding: 20px">

      <TemplateFeedback ref="pageFeedback" />

      <div v-html="tnc"></div>

    </div>

</template>

<script>
import helper from "@/components/Utility/Helper"
import TemplateFeedback from "@/components/Template/TemplateFeedback";

var querystring = require('querystring');

export default {
  name: "PageViewTnC",
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      tnc: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.loadData();
  },
  methods: {
    loadData() {
      let url = helper.SERVER_URL + '/api2/policy/terms'

      if (this.$route.query.operatorID) {
        url += '?operatorID=' + this.$route.query.operatorID
      }

      let feedbackItem = 'T&C'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // helper.SERVER_URL + '/api2/configure',
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.configure = response.data[0];
          this.tnc = this.configure.policy;
          this.showData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageViewTnC.vue